import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from 'axios';
export default {
  name: 'baiduAI',
  data: function data() {
    return {
      list: [],
      problem: ''
    };
  },
  mounted: function mounted() {},
  methods: {
    submitClick: function submitClick() {
      var _this = this;
      // this.toAudio()
      var problem = this.problem.replace(/\s+/g, '');
      if (!problem) {
        this.$message.info('请输入您要提问的问题');
        return;
      }
      this.list.push({
        content: this.problem,
        me: true
      });
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$api['baiduAiProblem']({
        problem: this.problem
      }).then(function (res) {
        if (res.data) {
          _this.list.push({
            content: res.data,
            you: true
          });
          loading.close();
        } else {
          loading.close();
          _this.$message.error('请求失败');
        }
      });
      this.problem = '';
    },
    deleteClick: function deleteClick() {
      this.list = [];
    } // 测试文本转语音
    ,
    toAudio: function toAudio() {
      var _this2 = this;
      axios({
        method: 'get',
        url: process.env.VUE_APP_API + "/voice/textToAudio/short",
        params: {
          content: '把他读出来'
        },
        headers: {
          'Content-Type': 'multipart/form-data; boundary = ' + new Date().getTime(),
          Authorization: localStorage.getItem('token')
        },
        responseType: 'blob'
      }).then(function (res) {
        console.log('res', res);
        if (res.data) {
          _this2.audioBlob = new Blob([res.data]);
          var audio = new Audio(window.URL.createObjectURL(_this2.audioBlob));
          audio.play();
        }
      });
    }
  }
};